import { takeEvery, select, cancel } from 'redux-saga/effects';
import { get } from 'lodash';
import { LOCATION_CHANGE } from '../../utils/redux/location-reducer';
import { LOGIN } from '../../constants/routes';
import { isLoggedInSelector } from './selectors';
import { redirect } from './authSaga';

function* loginPageSagaWorker(action) {
  const pathname = get(action, 'payload.pathname');
  const hasLogin = pathname.includes(LOGIN);

  if (hasLogin) {
    const isLoggedIn = yield select(isLoggedInSelector);
    if (isLoggedIn) {
      redirect();
    }
    yield cancel();
  }
}

export default function* loginPageSaga() {
  yield takeEvery(LOCATION_CHANGE, loginPageSagaWorker);
}



// WEBPACK FOOTER //
// ./src/redux/auth/login-redirect-saga.js